import { networkType } from "@/config";
import { createThirdwebClient } from "thirdweb";
import { base, baseSepolia } from "thirdweb/chains";
import { createWallet } from "thirdweb/wallets";

const clientId =
  process.env.NEXT_PUBLIC_THIRDWEB_CLIENT_ID ||
  "11fb2288161d8c2fb74666e399b9ac58";

if (!clientId) throw Error("Missing `NEXT_PUBLIC_THIRDWEB_CLIENT_ID`");

export const thirdWebClient = createThirdwebClient({
  clientId,
});

export const wallets = [
  createWallet("io.metamask"),
  createWallet("com.coinbase.wallet"),
  createWallet("me.rainbow"),
  createWallet("walletConnect"),
];

export const chain = networkType === "testnet" ? baseSepolia : base;
